'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/template-blog-article');

require('../sections/blog-related');

require('../sections/blog-filter');

require('../sections/blog-featured');

require('../../styles/templates/article.scss');

(0, _themeSections.load)(['blog-featured', 'blog-filter', 'blog-related', 'template-blog-article']);